function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#ddd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "4.5",
  cy: "12.5",
  r: "2.5"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  attributeType: "XML",
  dur: "1s",
  values: "#888 ; #ddd; #ddd ; #ddd",
  keyTimes: "0; 0.33; 0.66; 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: "11.5",
  cy: "12.5",
  r: "2.5"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  attributeType: "XML",
  dur: "1s",
  values: "#ddd ; #888; #ddd ; #ddd",
  keyTimes: "0; 0.33; 0.66; 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: "18.5",
  cy: "12.5",
  r: "2.5"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  attributeType: "XML",
  dur: "1s",
  values: "#ddd ; #ddd; #888 ; #ddd",
  keyTimes: "0; 0.33; 0.66; 1",
  repeatCount: "indefinite"
}))));